import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api';
import Select from 'react-select';

// بيانات تجريبية للمساجد (استبدل هذا بالبيانات الفعلية من Firebase)
const mosqueData = [
  {
    id: 1,
    name: 'مسجد الأقصى',
    city: 'القدس',
    country: 'فلسطين',
    lat: 31.7767,
    lng: 35.2345,
    image: 'https://encrypted-tbn1.gstatic.com/licensed-image?q=tbn:ANd9GcQPyJL_a8K7RKskq5J2w8PoD9nB7EUhRczqNaHShgCGDeNQmFtYoRiS7gUA4hk4cDCeTYaCUpG8roXzj65fUFffnH_B1V0c2IldDwF_KA',
    description: 'مسجد الأقصى هو أحد أقدم وأهم المساجد في العالم، يقع في القدس.',
    location: 'القدس، فلسطين',
  },
  {
    id: 2,
    name: 'مسجد السلطان أحمد',
    city: 'إسطنبول',
    country: 'تركيا',
    lat: 41.0085,
    lng: 28.9790,
    image: 'https://encrypted-tbn1.gstatic.com/licensed-image?q=tbn:ANd9GcQH1mHxnOITm5T-Jxb9tcdQiafAbZu0Zf1ke3mUiblaOcRaUOkoLMcJUJ_wRw6RwOebZpUyA4h2so9gHrSsdeCnRPRvjv_inVuia1d4Ng',
    description: 'مسجد السلطان أحمد مشهور ببلاطه الأزرق الجميل وهو من المعالم الرئيسية في إسطنبول.',
    location: 'سلطان أحمد، إسطنبول، تركيا',
  },
  {
    id: 3,
    name: 'مسجد الشيخ زايد',
    city: 'أبوظبي',
    country: 'الإمارات العربية المتحدة',
    lat: 24.4539,
    lng: 54.3773,
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQP08hQ-tDTE7QptExXJ4aJFCS1pfCmIzHFaw&s',
    description: 'مسجد الشيخ زايد هو مثال رائع على العمارة الإسلامية الحديثة في أبوظبي.',
    location: 'طريق الشيخ زايد، أبوظبي، الإمارات العربية المتحدة',
  },
];

const MosquesPage = () => {
  const [filteredMosques, setFilteredMosques] = useState(mosqueData);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedMosque, setSelectedMosque] = useState(null); // حالة للمسجد المحدد

  // توليد خيارات فريدة للدول والمدن
  const countries = [...new Set(mosqueData.map((mosque) => mosque.country))];
  const cities = [...new Set(mosqueData.filter(m => m.country === selectedCountry).map((mosque) => mosque.city))];

  // التعامل مع تغيير الدولة
  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption ? selectedOption.value : null);
    setSelectedCity(null);
  };

  // التعامل مع تغيير المدينة
  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption ? selectedOption.value : null);
  };

  // تصفية المساجد بناءً على الدولة والمدينة المحددة
  useEffect(() => {
    let filtered = mosqueData;
    if (selectedCountry) {
      filtered = filtered.filter((mosque) => mosque.country === selectedCountry);
    }
    if (selectedCity) {
      filtered = filtered.filter((mosque) => mosque.city === selectedCity);
    }
    setFilteredMosques(filtered);
  }, [selectedCountry, selectedCity]);

  return (
    <div className="container mx-auto p-8 bg-gray-50">
      <h1 className="text-4xl font-extrabold text-center mb-8 text-teal-700">المساجد حول العالم</h1>

      {/* قسم الفلترة */}
      <div className="flex flex-col sm:flex-row justify-between mb-8">
        <div className="w-full sm:w-1/3 mb-4 sm:mb-0">
          <Select
            options={countries.map(country => ({ value: country, label: country }))}
            onChange={handleCountryChange}
            placeholder="اختر الدولة"
            className="w-full rounded-lg shadow-md border-gray-300"
          />
        </div>
        <div className="w-full sm:w-1/3">
          <Select
            options={cities.map(city => ({ value: city, label: city }))}
            onChange={handleCityChange}
            placeholder="اختر المدينة"
            isDisabled={!selectedCountry}
            className="w-full rounded-lg shadow-md border-gray-300"
          />
        </div>
      </div>

      {/* قائمة المساجد */}
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">قائمة المساجد</h2>
        <ul className="space-y-6">
          {filteredMosques.map((mosque) => (
            <li
              key={mosque.id}
              className="bg-white p-6 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 cursor-pointer"
              onClick={() => setSelectedMosque(mosque)} // تعيين المسجد المحدد عند النقر عليه
            >
              <div className="flex items-center space-x-4">
                <img src={mosque.image} alt={mosque.name} className="w-16 h-16 object-cover rounded-full shadow-md" />
                <div>
                  <h3 className="text-xl font-semibold text-gray-800">{mosque.name}</h3>
                  <p className="text-sm text-gray-500">{mosque.city}, {mosque.country}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* لوحة تفاصيل المسجد */}
      {selectedMosque && (
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <h3 className="text-3xl font-semibold text-teal-700 mb-6">{selectedMosque.name}</h3>
          <img
            src={selectedMosque.image}
            alt={selectedMosque.name}
            className="w-full h-64 object-cover rounded-lg mb-6 shadow-md"
          />
          <p className="text-lg text-gray-700 mb-4">{selectedMosque.description}</p>
          <p className="font-semibold text-teal-700">الموقع:</p>
          <p className="text-lg text-gray-600">{selectedMosque.location}</p>
        </div>
      )}

      {/* تحميل Google Maps */}
      <LoadScript googleMapsApiKey="YOUR_GOOGLE_MAPS_API_KEY">
        {/* قسم الخريطة */}
        <div className="map-container border-4 border-teal-700 rounded-lg p-4 mt-8">
          <GoogleMap
            mapContainerStyle={{ height: "500px", width: "100%" }}
            center={{ lat: 20.0, lng: 30.0 }} // المركز الافتراضي
            zoom={2}
          >
            {filteredMosques.map((mosque) => (
              <Marker
                key={mosque.id}
                position={{ lat: mosque.lat, lng: mosque.lng }}
                onClick={() => setSelectedMosque(mosque)} // عرض نافذة المعلومات عند النقر على العلامة
              />
            ))}
          </GoogleMap>
        </div>
      </LoadScript>
    </div>
  );
};

export default MosquesPage;
